import { Injectable } from '@angular/core';
import { AbstractControlOptions, FormArray, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PledgeProductRead } from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option?) {
    let options: AbstractControlOptions = {};
    const sessionConsultant = option?.sessionConsultant;
    const isCristalisOrganization = option?.isCristalisOrganization || false;

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        realEstateAddress: this.formBuilder.group({
          street: [
            entity?.parameters?.realEstateAddress?.street || null,
            isCristalisOrganization && sessionConsultant
              ? Validators.nullValidator
              : Validators.required,
          ],
          zipCode: [entity?.parameters?.realEstateAddress?.zipCode || null],
          city: [
            entity?.parameters?.realEstateAddress?.city || null,
            isCristalisOrganization && sessionConsultant
              ? Validators.nullValidator
              : Validators.required,
          ],
          country: [
            entity?.parameters?.realEstateAddress?.country
              ? {
                  value: entity?.parameters?.realEstateAddress?.country,
                  // id: "FR",
                  valueGb: entity?.parameters?.realEstateAddress?.country,
                }
              : null,
          ],
        }),
        realEstateSurface: [entity?.parameters?.realEstateSurface || null],
        realEstatePropertyType: [
          entity?.parameters?.realEstatePropertyType || null,
          isCristalisOrganization && sessionConsultant
            ? Validators.required
            : Validators.nullValidator,
        ],
        realEstateRent: [entity?.parameters?.realEstateRent || null],
        realEstateType: [
          entity?.parameters?.realEstateType || null,
          isCristalisOrganization && sessionConsultant
            ? Validators.required
            : Validators.nullValidator,
        ],
        fiscalityLawType: [
          entity?.parameters?.fiscalityLawType || null,
          isCristalisOrganization && sessionConsultant
            ? Validators.required
            : Validators.nullValidator,
        ],
        purchaseDate: [
          entity?.parameters?.purchaseDate || null,
          isCristalisOrganization && sessionConsultant
            ? Validators.required
            : Validators.nullValidator,
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as FormArray;
  }
  extract() {
    const formValue = _.cloneDeep(this.form.value);
    const products = formValue.products.map(product => {
      const realEstateAddress = this.transformAddress(
        product?.parameters.realEstateAddress,
      );

      return {
        ...product,
        parameters: {
          ..._.omit(product.parameters, ['realEstateAddress']),
          realEstateAddress: { ...realEstateAddress },
        },
      };
    });
    const obj = {
      ...formValue,
      products,
    };

    return obj.products;
  }
  transformAddress(originalAddress: {
    street: string;
    street2?: string;
    zipCode: string;
    city: string;
    country: any;
  }) {
    const address = originalAddress
      ? (({ country, ...address }) => ({
          ...address,
          country: country?.value ? country.value : country || '',
        }))(originalAddress)
      : {};
    return address;
  }
}
